export default function DetailTitleBlock({title}: {title: string}) {
    return (
        <div className="relative -ml-4 flex min-w-0 items-center self-stretch bg-black py-3 pr-3 pl-4">
            <h2 className="min-w-0 text-2xl font-semibold tracking-wide text-white"
                style={{fontVariant: "small-caps"}}>
                {title}
            </h2>
            <span aria-hidden="true"
                  className="absolute inset-y-0 left-full w-6 bg-black"
                  style={{clipPath: "polygon(0 0, 100% 100%, 0 100%)"}}/>
        </div>
    );
}
